import { ADMIN_ROLES } from '../utils/roleHelpers';
import { CandidateStatus } from '../api/candidates.api';

/* ── Onboarding-Constants ── */
export const ONBOARDING_TEXT = {
  pageTitle: 'Onboarding Form',
  companyBadge: 'PeopleSuite',
  greetingSuffix: ', please fill in the details below to complete your onboarding.',

  documentsHeading: 'Onboarding Required Documents',
};

export const PRIOR_EMPLOYMENT_MODAL_TEXT = {
  title: 'Prior Employment History',
  body: 'Have you added all your prior employment history? If you have worked at other companies before your current organization, please add them.',
  btnYes: 'Yes, Proceed',
  btnNo: 'No, Add More',
};

/* ── BannerParticles ── */
export const BANNER_PARTICLES_TEXT = {
  bannerTitle: 'Welcome to PeopleSuite',
  bannerSubtitle: 'Your all-in-one HR management solution',
};

/* ── Onboarding-Constants ── */

export const TODAY_STR = new Date().toISOString().split('T')[0];

export const MAX_DOB = (() => {
  const d = new Date();
  d.setFullYear(d.getFullYear() - 18);
  return d.toISOString().split('T')[0];
})();

export const GENDER_OPTIONS = [
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
  { value: 'Other', label: 'Other' },
];

export const NATIONALITY_OPTIONS = [
  { value: 'Indian', label: 'Indian' },
  { value: 'Other', label: 'Other' },
];

export const LANGUAGE_OPTIONS = [
  'English',
  'Tamil',
  'Telugu',
  'Hindi',
  'Kannada',
  'Malayalam',
  'Other',
];

export const MARITAL_OPTIONS = [
  { value: 'Single', label: 'Single' },
  { value: 'Married', label: 'Married' },
  { value: 'Divorced', label: 'Divorced' },
  { value: 'Widowed', label: 'Widowed' },
];

export const BLOOD_GROUP_OPTIONS = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'].map((bg) => ({
  value: bg,
  label: bg,
}));

export const DEGREE_OPTIONS = [
  '10th',
  '12th',
  'Diploma',
  "Bachelor's",
  "Master's",
  'PhD',
  'Other',
].map((d) => ({ value: d, label: d }));

export const FIELD_OF_STUDY_OPTIONS = [
  'Computer Science',
  'Information Technology',
  'Electronics',
  'Mechanical',
  'Civil',
  'Business Administration',
  'Commerce',
  'Arts',
  'Science',
  'Other',
].map((f) => ({ value: f, label: f }));

export const RELATIONSHIP_OPTIONS = ['Father', 'Mother', 'Spouse', 'Child', 'Sibling', 'Other'].map(
  (r) => ({ value: r, label: r })
);

export const SECTIONS = [
  'Personal Details',
  'Experience',
  'Education',
  'Certifications',
  'Family Details',
  'References',
];

/* ── OnboardingFormPage ── */
/* Note: SECTIONS above doubles as this page's step list. */

export const GENDERS = ['Male', 'Female', 'Other', 'Prefer not to say'];
export const NATIONALITIES = ['Indian', 'American', 'British', 'Canadian', 'Australian', 'Other'];
export const RELIGIONS = ['Hinduism', 'Islam', 'Christianity', 'Sikhism', 'Buddhism', 'Other'];
export const BLOOD_GROUPS = ['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-','Bombay','Rh Null'];
export const MARITAL = ['Single', 'Married', 'Divorced', 'Widowed'];
export const LANGUAGES = ['English', 'Tamil', 'Telugu', 'Hindi', 'Kannada', 'Malayalam', 'Other'];
export const RELATIONSHIPS = [
  'Father',
  'Mother',
  'Spouse',
  'Son',
  'Daughter',
  'Brother',
  'Sister',
  'Other',
];
export const DEGREES = [
  '10th',
  '12th',
  'B.E.',
  'B.Tech',
  'B.Sc',
  'B.Com',
  'B.A.',
  'M.Tech',
  'M.Sc',
  'M.Com',
  'M.A.',
  'MBA',
  'MCA',
  'BCA',
  'Ph.D',
  'Diploma',
  'Other',
];
export const FIELDS = [
  'Computer Science',
  'Information Technology',
  'Electronics',
  'Mechanical',
  'Civil',
  'Electrical',
  'Commerce',
  'Arts',
  'Science',
  'Management',
  'Law',
  'Medicine',
  'Other',
];

export const MAX_FILE_SIZE_MB = 10;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
export const ALLOWED_FILE_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];

export const PAN_RE = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
export const AADHAAR_RE = /^\d{12}$/;
export const PHONE_RE = /^\d{10}$/;
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const ALPHA_RE = /^[A-Za-z\s]+$/;

/* ── OnboardingReportsPage ── */
export const ONBOARDING_REPORTS_STATUS_LABELS: Record<string, string> = {
  moved_to_onboarding: 'Not Completed',
  resubmission_requested: 'Resubmission',
  resubmitted: 'Resubmitted',
  onboarding_completed: 'Completed',
  withdrawn: 'Withdrawn',
  converted: 'Moved to User',
};

/* ── OnboardingPage ── */
export const STATUS_LABEL: Record<CandidateStatus, string> = {
  invited: 'Invited',
  not_completed: 'Not Completed',
  completed: 'Completed',
  withdrawn: 'Withdrawn',
  moved_to_onboarding: 'Moved to Onboarding',
  onboarding_completed: 'Onboarding Completed',
  converted: 'Converted to Employee',
  resubmission_requested: 'Resubmission',
  resubmitted: 'Resubmitted',
};

export const ONBOARDING_REPORTS_TEXT = {
  bannerTitle: 'Onboarding Reports',
  bannerSubtitle: 'Track onboarding progress and pending resubmissions',

  searchPlaceholder: 'Search by name or email…',
  allStatusesOption: 'All Statuses',
  resetButton: 'Reset',

  countMovedToOnboarding: 'Onboarding Initiated',
  countResubmissionRequested: 'Resubmission Required',
  countResubmitted: 'Resubmissions Received',
  countOnboardingCompleted: 'Onboarding Completed',
  countWithdrawn: 'Withdrawn',
  countTotal: 'Total Candidates',

  colName: 'Name',
  colEmail: 'Email',
  colPhone: 'Phone',
  colStatus: 'Status',
  colCreated: 'Created',

  loadingLabel: 'Loading…',
  noResultsLabel: 'No candidates found.',
  previousLabel: 'Previous',
  nextLabel: 'Next',
  rowsPerPageLabel: 'Rows per page:',
} as const;

/* ── Onboarding Sidebar Nav Items ── */
export const NAV_ONBOARDING = {
  label: 'Onboarding',
  icon: 'how_to_reg',
  path: '/onboarding',
  roles: ADMIN_ROLES,
  departments: ['HR', 'Talent Acquisition'] as string[],
} as const;

export const NAV_ONBOARDING_REPORTS = {
  label: 'Onboarding Reports',
  icon: 'assignment_turned_in',
  path: '/reports/onboarding',
  roles: ADMIN_ROLES,
  departments: ['HR', 'Talent Acquisition'] as string[],
} as const;

export const BACKGROUND_QUESTIONS = {
  convictedCriminalOffense: 'Have you ever been convicted for a criminal offense?',
  medicalTreatmentHistory: 'Kindly indicate whether smoking or alcohol consumption is part of your lifestyle?',
  preExistingCondition: 'Do you have any pre-existing medical condition / illness?',
  physicalDefect: 'Do you suffer from any physical defect or partial disability?',
  wearsGlasses: 'Do you wear glasses / contact lenses?',
  professionalAssociation: 'Are you a member of any professional association / club / society?',
  hobbies: 'Please list any interests in sports or other hobbies',
  details: 'Please give details',
};
